<template>
    <ui-sidepage extra-large :close="() => closeMe(close)" :title='`${rams.contractReference} • ${rams.title}`'
                 :subtitle="``" :go-transparent="true" v-if="rams">
        <label class="my-0 py-0 m-0">Send RAMS</label>
        <div class="mt-2 mb-8">
            <ui-input label="Send to" v-model="to"
                      placeholder="Email address/phone number (multiple separated with commas)..."
                      class="xl:col-span-12"
                      @input="error = false"
                      @focus=""
            ></ui-input>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
            <div class="flex flex-col md:flex-row flex-wrap m-2">
                <div class="flex-1 mt-3.5 pt-2 mr-3 warning text-yellow-600 text-sm text-right">
                </div>
                <ui-button-new primary class="whitespace-nowrap mt-4 ml-4" :loading="busy" @click="sendForApproval"
                               v-if="(rams.status === 'Draft' || rams.status === 'Awaiting Client Response')"
                               v-text="'Send for Approval'"></ui-button-new>
                <ui-button-new primary class="whitespace-nowrap mt-4 ml-4" :loading="busy" @click="send"
                               v-if="(rams.status !== 'Draft' && rams.status !== 'Awaiting Client Response')"
                               v-text="'Send for Viewing'"></ui-button-new>
            </div>
        </div>
        <send-log :send-log="combineSendLogs" v-if="this.rams.sendLog" @revoke="revoke" @resend="resend"></send-log>
    </ui-sidepage>
</template>

<script>
import UiSidepage from "../../../ui/UiSidepage.vue";
import RamsExistingUsersSearch from "./RamsExistingUsersSearch.vue";
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDropdown from "../../../ui/UiDropdown.vue";
import moment from "moment";
import UiInput from "../../../ui/UiInput.vue";
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiDataGridItem from "../../../ui/UiDataGridItem.vue";
import UiButtonNew from "../../../ui/UiButtonNew.vue";
import UiFormSection from "../../../ui/UiFormSection.vue";
import UiDropdownDivider from "../../../ui/UiDropdownDivider.vue";
import SendLog from "../../../send-log/SendLog.vue";

export default {
    components: {
        SendLog,
        UiDropdownDivider,
        UiFormSection,
        UiButtonNew,
        UiDataGridItem,
        UiTextarea, UiInput,
        UiDropdown, UiDropdownItem,
        AutoresizableTextarea,
        RamsExistingUsersSearch,
        UiSidepage
    },
    props: {
        item: Object,
        close: Function,
    },
    watch: {},
    computed: {
        combineSendLogs() {
            return this.rams.sendLog.map((a) => {
                return a;
            }).concat(...this.rams.attendees.map((a) => a.sendLog ? a.sendLog.map((b) => {
                return b;
            }) : [])).sort((a, b) => moment(b.requested.at).unix() - moment(a.requested.at).unix())
        }
    },
    data() {
        return {
            email: '',
            rams: Object,
            error: '',
            moment: moment,
            busy: false,
            closed: false,
            to: ''
        }
    },
    methods: {
        closeMe(close) {
            this.closed = true
            if (this.reloading) {
                clearTimeout(this.reloading)
            }
            close()
        },
        async send() {
            this.busy = true;
            let response = await this.rams.send(this.to)
            this.busy = false;
            if (response.status !== 'ok') {
                if (response.data.message.startsWith('Invalid email')) {
                    this.error = 'ERROR: Cannot determine how to handle "' + this.to + '" - is this a valid email address or phone number?'
                }
            } else {
                this.to = '';
            }
        },
        revoke(i) {
            this.rams.revoke(i.id);
        },
        resend(i) {
            this.rams.resend(i.id);
        },
        async sendForApproval() {
            this.busy = true;
            let response = await this.rams.requestApproval(this.to)
            this.busy = false;
            if (response.status !== 'ok') {
                if (response.data.message.startsWith('Invalid email')) {
                    this.error = 'ERROR: Cannot determine how to handle "' + this.to + '" - is this a valid email address or phone number?'
                }
            } else {
                this.to = '';
            }
        },
    },
    async mounted() {
        this.rams = this.item
    }
}
</script>
